export default __webpack_public_path__ + "static/media/padlock.8501dff4.svg";